module.exports = {
  chainWebpack: config => {
    config.plugins.delete('prefetch');
  },
  publicPath: process.env.NODE_ENV === 'production'
    ? '/planner/'
    : '/',
  devServer: {
    https: process.env.NODE_ENV === 'production'
    ? true
    : false,
  }
}